import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import icons from "../../../assets/images/constantIcons";
import * as Yup from "yup";
import toast from "react-hot-toast";
import apiService, { formatRupees, handleError } from "../../Common/ApiCommon/ApiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const EditCustomerForm = ({onClose,editPopup,customerId,fetchCustomers,password}) => {
  const [customer, setCustomerData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [location, setLocation] = useState([]);

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const response = await apiService.get(`/customer_users/${customerId}?password=${password}`);
        console.log("response",response.data);
        
        setCustomerData(response.data);
      } catch (errors) {
        handleError(errors)
      }
    };

    if (customerId) {
      fetchCustomerData();
    }
  }, [customerId]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      full_name: customer?.full_name || "",
      nick_name: customer?.nick_name || "",
      email: customer?.email || "",
      mobile_no: customer?.mobile_no || "",
      dob: customer?.dob || "",
      city: customer?.city || "",
      due_limit:formatRupees(customer?.due_limit)  || ""
    },
    validationSchema: Yup.object({
      full_name: Yup.string()
        .trim()
        .matches(
          /^[A-Za-z\s]+$/,
          "Full name cannot contain numbers or special characters"
        )
        .min(2, "Full name must be at least 2 characters")
        .max(50, "Full name cannot exceed 50 characters")
        .required("Full name is required"),
      nick_name: Yup.string()
        .trim()
        .matches(
          /^[A-Za-z\s]+$/,
          "Nick name cannot contain numbers or special characters"
        )
        .min(2, "Nick name must be at least 2 characters")
        .max(30, "Nick name cannot exceed 30 characters")
        .required("Nick name is required"),
      email: Yup.string().email("Invalid email format"),
      mobile_no: Yup.string()
        .required("Mobile number is required"),
      dob: Yup.string()
        .test("valid-date", "Invalid date", (value) => {
          if (!value) return true; // Allow empty values
          return !isNaN(new Date(value).getTime());
        })

        .test("dob", "Date of birth cannot be in the future", (value) => {
          if (!value) return true; // Allow empty values
          const selectedDate = new Date(value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return selectedDate <= today;
        }),

      city: Yup.string()
        .trim()
        .matches(
          /^[A-Za-z\s]+$/,
          "City cannot contain numbers or special characters"
        )
        .matches(/^(?!\s*$).+/, "City cannot be empty or only spaces") // Prevents only spaces
        .min(2, "City name must be at least 2 characters")
        .max(50, "City name must be 50 characters or less"),
    }),
    onSubmit: async (values) => {
      setIsSubmitting(false);
      try {
        const formattedData = {
          customer_user: {
            ...values,
            due_limit: values.due_limit ? values.due_limit : 0,
          },
        };
        const response = await apiService.put(
          `/customer_users/${customerId}`,
          formattedData
        );
        

        if (response.status === 200) {
          onClose();
          toast.success(response.message, { duration: 2000 });
          fetchCustomers();
        }
      } catch (errors) {
        handleError(errors);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  // locations get api
  const fetchLocations = async () => {
    try {
      const response = await apiService.get("/locations");
      setLocation(response.data);
    } catch (error) {
      toast.error("Faild to fetch location.", { duration: 200 });
    }
  };
  useEffect(() => {
    fetchLocations();
  }, []);
  return (
    editPopup && (
      <>
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
            <div
              className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
              onClick={onClose}
            >
              <icons.IoClose className="text-green700" />
            </div>

            <h2 className="text-xl font-semibold mb-6 text-G500 text-start">
              Edit Player
            </h2>
            <form
              onSubmit={formik.handleSubmit}
              className="space-y-4 text-start h-[70vh] 2xl:h-auto overflow-y-auto vertical"
            >
              {/* Full Name */}
              <div className="text-G300">
                <label className="block text-sm font-normal mb-2">
                  Full name <span className="text-red ">*</span>
                </label>
                <input
                  type="text"
                  name="full_name"
                  value={formik.values.full_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="inputtext"
                  placeholder="Full name"
                />
                {formik.errors.full_name && formik.touched.full_name && (
                  <div className="text-red text-sm">
                    {formik.errors.full_name}
                  </div>
                )}
              </div>

              {/* Nickname */}
              <div className="text-G300">
                <label className="block text-sm font-normal mb-2">
                  Nick name <span className="text-red ">*</span>
                </label>
                <input
                  type="text"
                  name="nick_name"
                  value={formik.values.nick_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="inputtext "
                  placeholder="Nick name"
                />
                {formik.errors.nick_name && formik.touched.nick_name && (
                  <div className="text-red text-sm">
                    {formik.errors.nick_name}
                  </div>
                )}
              </div>

              {/* Email */}
              <div className="text-G300">
                <label className="block text-sm font-normal mb-2">Email</label>
                <input
                  type="text"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="inputtext "
                  placeholder="nathan.roberts@example.com"
                />
                {formik.errors.email && formik.touched.email && (
                  <div className="text-red text-sm">{formik.errors.email}</div>
                )}
              </div>

              {/* Mobile */}
              <div className="text-G300">
                <label className="block text-sm font-normal mb-2">
                  Mobile <span className="text-red ">*</span>
                </label>
                <PhoneInput
                country={'in'}
                value={formik.values.mobile_no}
                onChange={(value) => formik.setFieldValue('mobile_no', value)}
                onBlur={formik.handleBlur}
                disableDropdown
                enableSearch={false}
                countryCodeEditable={false}
                onlyCountries={['in']}
                placeholder="80679 35463"
                inputProps={{
                  name: 'mobile_no',
                  required: true,
                  className: 'w-full inputtext', 
                }}
                buttonStyle={{ display: 'none' }} 
              />
                {formik.errors.mobile_no && formik.touched.mobile_no && (
                  <div className="text-red text-sm">
                    {formik.errors.mobile_no}
                  </div>
                )}
              </div>

              {/* Date of Birth */}
              <div className="text-G300 w-full ">
                <label className="block text-sm font-normal mb-2">
                  Date of Birth
                </label>
                <div className="relative">
                  <DatePicker
                    selected={
                      formik.values.dob ? new Date(formik.values.dob) : null
                    }
                    onChange={(dob) =>
                      formik.setFieldValue(
                        "dob",
                        dob.toLocaleDateString("en-CA")
                      )
                    }
                    maxDate={new Date()}
                    placeholderText="yyyy-mm-dd"
                    dateFormat="yyyy-MM-dd"
                    className="inputtext placeholder:text-G50 w-full pr-10"
                  />
                  <icons.MdOutlineCalendarMonth className="absolute right-3 top-3 text-green pointer-events-none" />
                </div>
                {formik.errors.dob && formik.touched.dob && (
                  <div className="text-red text-sm">{formik.errors.dob}</div>
                )}
              </div>

              {/* City */}
              <div className="text-G300">
                <label className="block text-sm mb-2">
                  City
                </label>
                <select
                  name="city"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="inputtext"
                >
                  <option value="" disabled>
                    Select City
                  </option>
                  {location.map((loc) => (
                    <option key={loc.id} value={loc.name}>
                      {loc.name}
                    </option>
                  ))}
                </select>
                {formik.errors.city && formik.touched.city && (
                  <div className="text-red text-sm">{formik.errors.city}</div>
                )}
              </div>
              <div className="text-G300">
                <label className="block text-sm font-normal mb-2">Credit Limit </label>
                <div className="relative">
                <span className="absolute inset-y-0 left-3 flex items-center text-green font-semibold">₹</span>
                <input
                  type="number"
                  name="due_limit"
                  value={formik.values.due_limit}
                  onChange={formik.handleChange}
                  onWheel={(e) => e.target.blur()} // Prevents changing value on scroll
                  onBlur={formik.handleBlur}
                  className="inputtext text-green placeholder:text-green"
                  style={{ paddingLeft: "25px" }}
                  placeholder="0"
                />
                 </div>
                {formik.errors.due_limit && formik.touched.due_limit && (
                  <div className="text-red text-sm">
                    {formik.errors.due_limit}
                  </div>
                )}
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-4 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    formik.resetForm();
                    onClose();
                  }}
                  className="w-[75px] sm:w-[93px] text-sm py-2 text-center border border-green text-green rounded-lg"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className={`w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg ${isSubmitting
                      ? "bg-green50 cursor-not-allowed"
                      : "bg-green text-white"
                    }`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </>
    )
  );
};

export default EditCustomerForm;
